document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[class^="section-"]').forEach(section => {
    const tabButtons = section.querySelectorAll('.category-tab');
    const tabContents = section.querySelectorAll('.tab-content');

    function openTab(tabId) {
      tabContents.forEach(content => {
        content.style.display = content.id === tabId ? 'flex' : 'none';
      });
      tabButtons.forEach(button => {
        button.classList.toggle('active', button.dataset.tabTarget === tabId);
      });
    }

    tabButtons.forEach(button => {
      button.addEventListener('click', function () {
        openTab(this.dataset.tabTarget);
      });
    });

    if (tabButtons.length > 0) {
      openTab(tabButtons[0].dataset.tabTarget);
    }
  });
});
